import React, { useEffect, useRef, useState } from "react";
import AdminHeader from "../../component/Header";
import Sidebar from "../../component/Sidebar";
import { useNavigate } from "react-router-dom";
import AdminFooter from "../../component/Footer";
import { ApiService } from "../../component/Services/apiservices";
import moment from "moment";

function Dashboard() {
    const [subuerbProperties, setSuberbProperties] = useState([])
    const [stateProperties, setStateProperties] = useState([])
    const [dashboard, setDashboard] = useState({})
    const [currency, setCurrency] = useState()
    const didMountRef = useRef(true)
    const Navigate = useNavigate()
    useEffect(() => {

        if (didMountRef.current) {
            if (JSON.parse(localStorage.getItem('USER_DATA')) == null) {
                Navigate("/")
            }
            else {

            }
            getTopPropertyList()
            getTotalPropertyCount()
            getCurrency()
        }
        didMountRef.current = false;
    })

    const getTopPropertyList = () => {
        ApiService.fetchData('/admin/dashboard/get-top-properties').then((res) => {
            if (res.status == 'success') {
                setSuberbProperties(res.topSuburbs)
                setStateProperties(res.topStates)
            } else {

            }
        }).catch((error) => {

        })
    }
    function formatToUSD(num) {
        const units = ["", "K", "M", "B", "T"]; // Thousand, Million, Billion, Trillion
        let unitIndex = 0;

        while (num >= 1000 && unitIndex < units.length - 1) {
            num /= 1000;
            unitIndex++;
        }

        return `${num.toFixed(2)} ${units[unitIndex]}`;
    }


    const getTotalPropertyCount = () => {
        ApiService.fetchData('/admin/dashboard/gettotalpropertycount').then((res) => {
            if (res.status == 'success') {
                setDashboard(res.data)
            } else {

            }
        }).catch((error) => {
        })
    }
    const getCurrency = () => {
        ApiService.fetchData("admin/getadminsettingdata").then((res) => {
            if (res?.status == "success") {
                setCurrency(res.data.admin_Property_currency)
            }
        }).catch((error) => { })
    }
    return (
        <>
            <div id="layout-wrapper">

                <AdminHeader />
                <Sidebar />
                <div class="vertical-overlay"></div>
                <div class="main-content">
                    <div class="page-content">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12">
                                    <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 class="mb-sm-0">Analytics</h4>
                                        <div class="page-title-right">
                                            <ol class="breadcrumb m-0">
                                                <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboards</a></li>
                                                <li class="breadcrumb-item active">Analytics</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-12">
                                    <div class="card crm-widget">
                                        <div class="card-body p-0">
                                            <div class="row row-cols-lg-3 row-cols-md-3 row-cols-1 g-0">
                                                <div class="col">
                                                    <div class="py-4 px-3">
                                                        <h5 class="text-muted text-uppercase fs-13">Properties</h5>
                                                        <div class="d-flex align-items-center">
                                                            <div class="avatar-sm flex-shrink-0">
                                                                <span class="avatar-title bg-primary rounded-2 fs-2">
                                                                    <i class="ri-space-ship-line display-6 text-white fs-3"></i>
                                                                </span>
                                                            </div>
                                                            <div class="flex-grow-1 ms-3">
                                                                <h2 class="mb-0">
                                                                    <span class="counter-value" >
                                                                        {(dashboard.totalProperties || 0).toLocaleString()}
                                                                    </span>
                                                                </h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div class="py-4 px-3">
                                                        <h5 class="text-muted text-uppercase fs-13">Property Value</h5>
                                                        <div class="d-flex align-items-center">
                                                            <div class="avatar-sm flex-shrink-0">
                                                                <span class="avatar-title bg-warning rounded-2 fs-2">
                                                                    <i class="ri-exchange-dollar-line display-6 text-white fs-3"></i>
                                                                </span>
                                                            </div>
                                                            <div class="flex-grow-1 ms-3">
                                                                <h2 class="mb-0">{currency ? currency : '$'}{formatToUSD(dashboard.totalPropertyValue || 0)}</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div class="py-4 px-3">
                                                        <h5 class="text-muted text-uppercase fs-13">Equity</h5>
                                                        <div class="d-flex align-items-center">
                                                            <div class="avatar-sm flex-shrink-0">
                                                                <span class="avatar-title bg-info rounded-2 fs-2">
                                                                    <i class="ri-pulse-line display-6 text-white fs-3"></i>
                                                                </span>
                                                            </div>
                                                            <div class="flex-grow-1 ms-3">
                                                                <h2 class="mb-0">{currency ? currency : '$'}{formatToUSD(dashboard.totalPropertyEquity || 0)}</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div class="col">
                                                    <div class="py-4 px-3">
                                                        <h5 class="text-muted text-uppercase fs-13">Cashflow</h5>
                                                        <div class="d-flex align-items-center">
                                                            <div class="avatar-sm flex-shrink-0">
                                                                <span class="avatar-title bg-success rounded-2 fs-2">
                                                                    <i class="ri-trophy-line display-6 text-white fs-3"></i>
                                                                </span>
                                                            </div>
                                                            <div class="flex-grow-1 ms-3">
                                                                <h2 class="mb-0">{currency?currency:'$'}{ formatToIndianUnits(dashboard.totalPropertycashFlow||0) }</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-6">
                                    <div class="card">
                                        <div class="card-header align-items-center d-flex">
                                            <h3 class="card-title mb-0 flex-grow-1 fw-bold text-center" style={{ color: "#672d5f" }}>Top 10 Suburb</h3>
                                        </div>
                                        {subuerbProperties && subuerbProperties.length > 0 ?
                                            <>
                                                <div class="card-body">
                                                    <div class="table-responsive table-card">
                                                        <table class="table table-borderless table-hover table-nowrap align-middle mb-0">
                                                            <thead class="table-light">
                                                                <tr class="text-muted">
                                                                    <th scope="col" className="text-center">Rank</th>
                                                                    <th scope="col" className="text-center">Suburb</th>
                                                                    <th scope="col" className="text-center">Count</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {subuerbProperties && subuerbProperties.map((item, index) => {
                                                                    return (<>
                                                                        <tr key={index}>
                                                                        <td className="text-center">{index+1}</td>
                                                                            <td className="text-center">
                                                                                {item?._id}

                                                                            </td>
                                                                            <td className="text-center">{item?.count}</td>

                                                                        </tr>

                                                                    </>)
                                                                })}


                                                            </tbody>

                                                        </table>

                                                    </div>

                                                </div></> : <div className="text-center">No Data Found</div>}
                                    </div>
                                </div>
                                <div class="col-xl-6">
                                    <div class="card">
                                        <div class="card-header align-items-center d-flex">
                                            <h3 class="card-title mb-0 flex-grow-1 fw-bold text-center" style={{ color: "#672d5f" }}>Top 10 State</h3>
                                        </div>
                                        {stateProperties && stateProperties.length > 0 ?
                                            <>
                                                <div class="card-body">
                                                    <div class="table-responsive table-card">
                                                        <table class="table table-borderless table-hover table-nowrap align-middle mb-0">
                                                            <thead class="table-light">
                                                                <tr class="text-muted">
                                                                <th scope="col" className="text-center">Rank</th>
                                                                    <th scope="col" className="text-center">State</th>
                                                                    <th scope="col" className="text-center">Count</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {stateProperties && stateProperties.map((item, index) => {
                                                                    return (<>
                                                                        <tr key={index}>
                                                                        <td className="text-center">{index+1}</td>
                                                                            <td className="text-center">
                                                                                {item?._id}

                                                                            </td>
                                                                            <td className="text-center">{item?.count}</td>

                                                                        </tr>
                                                                    </>)
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div></> : <div className="text-center">No Data Found</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AdminFooter />
                </div>


            </div>
        </>
    )
}
export default Dashboard